<template>
  <component
    :is="useScrollSpy ? 'scrollactive' : 'div'"
    v-bind="useScrollSpy ? scrollactiveProps : {}"
    v-on="useScrollSpy ? { itemchanged: onItemChanged } : {}"
  >
    <div
      v-if="menuItems"
      class="color-black-magic d-flex menu-side-nav-padding"
    >
      <v-btn
        class="scrollactive-item d-flex justify-start"
        :class="{
          'active-side-nav': !useScrollSpy && section === selectedSection,
        }"
        v-for="(items, section) in navItems"
        :key="section"
        :to="{
          name: 'home',
          hash: `#${slug(section.replace(/^\d/, 'abc$&'))}`,
        }"
        min-height="40"
        rounded
        text
      >
          <span
            style="max-width: 208px"
            class="d-inline-block font-size-md no-uppercase text-truncate"
          >{{ section }}</span
          >
      </v-btn>
    </div>
  </component>
</template>

<script>
import { slug } from "github-slugger";
import { mapGetters, mapState } from "vuex";

export default {
  name: "TemplateNav",
  computed: {
    ...mapGetters('menu', { menuItems: 'bySection', selectedSection: 'selectedSection' }),
    ...mapGetters("template", { templateItems: "byCategory" }),
    ...mapState({
      websiteFormat: (state) => state.store.info.store_info.customization?.website.style.website_format ?? "all_items",
    }),
    navItems() {
      return this.websiteFormat === "menu_only" ? this.menuItems : this.templateItems;
    },
    scrollactiveProps() {
      return {
        'active-class': 'active-side-nav',
        highlightFirstItem: true,
        modifyUrl: false,
        offset: this.offset,
      };
    },
    useScrollSpy() {
      return this.websiteFormat !== 'menu_only';
    },
  },
  created() {
    window.addEventListener("scroll", this.setOffset);
  },
  data() {
    return {
      offset: -20,
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.setOffset);
  },
  methods: {
    onItemChanged(event, currentItem, previousItem) {
      if (this.$route.path !== "/") return;
      const collection = [...currentItem.parentElement.children];
      const isIncrease = collection.indexOf(previousItem) < collection.indexOf(currentItem);
      try {
        currentItem[isIncrease ? "nextElementSibling" : "previousElementSibling"].scrollIntoView();
      } catch (e) {
        currentItem.scrollIntoView();
      }
    },
    setOffset() {
      this.offset = 158;
    },
    slug,
  },
};
</script>

<style scoped>
.active:hover::before,
.theme--light.v-btn--active::before {
  opacity: 0;
}

.active-side-nav {
  background-color: var(--v-primary-base);
  color: var(--color-white) !important;
}

.menu-side-nav-padding {
  padding-right: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
}

</style>
